import { configureStore } from '@reduxjs/toolkit'

import auth from './auth'
import users from './users'
import userStats from './userStats'
import usersPaginated from './usersPaginated'
import teamsPaginated from './teamsPaginated'
import miscdata from './miscdata'
import toast from './toast'
import loader from './loader'
import supports from './support'
import navs from './navs'
import filter from './filter'
import filtert from './filtert'
import faqs from './faq'
import scores from './scores'
import teams from './teams'
import posts from './posts'
const store = configureStore({
    reducer: {
        auth,
        users,
        userStats,
        usersPaginated,
        teamsPaginated,
        miscdata,
        toast,
        loader,
        supports,
        navs,
        filter,
        scores,
        teams,
        filtert,
        faqs,
        posts
    }
})

export { store }